import styled from 'styled-components';

export const Container = styled.div<{
  $isMobile: boolean;
  $isDisabled?: boolean;
}>`
  padding-bottom: ${({ $isMobile }) => ($isMobile ? 16 : 30)}px;

  /**
    * Роут туристов заблокирован, пока не подтверденны данные клиента
   */
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
      position: relative;
      opacity: 0.5;
      user-select: none;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
  `}
`;
